import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import "./AdminHackingMatches.css";

export default function AdminHackingMatches() {
  const [bets, setBets] = useState([]);
  const [editedBets, setEditedBets] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [searchUsername, setSearchUsername] = useState("");

  // ================= FETCH BETS =================
  useEffect(() => {
    fetchBets();
  }, []);

  async function fetchBets() {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, "userBets"));
      const list = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setBets(list);
    } catch (err) {
      console.error("FETCH ERROR:", err);
    } finally {
      setLoading(false);
    }
  }

  // ================= MESSAGE =================
  const showMessage = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), 4000);
  };

  // ================= SEARCH FILTER =================
  // 🔥 HII NDIO INAYOFANYA UONE MICHEZO YOTE YA USER
  const filteredBets = bets.filter((bet) => {
    if (!searchUsername.trim()) return true;

    return (
      bet.username &&
      bet.username
        .toString()
        .trim()
        .toLowerCase()
        .includes(searchUsername.trim().toLowerCase())
    );
  });

  // ================= EDIT HANDLER =================
  const handleEdit = (id, field, value) => {
    setEditedBets((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  // ================= DUPLICATE DETECTION =================
  const suspiciousGroups = (() => {
    const map = {};

    filteredBets.forEach((bet) => {
      const amount = Number(bet.betInTsh || bet.betInUsdt || 0);
      const match = `${bet.teamA} vs ${bet.teamB}`;
      const key = `${bet.username}|${match}|${amount}`;

      if (!map[key]) map[key] = [];
      map[key].push(bet);
    });

    return Object.values(map).filter((g) => g.length >= 2);
  })();

  // ================= MATCH SUMMARY =================
  const matchSummary = (() => {
    const summary = {};

    filteredBets.forEach((bet) => {
      const key = `${bet.teamA} vs ${bet.teamB}`;

      if (!summary[key]) {
        summary[key] = {
          players: new Set(),
          totalTsh: 0,
          totalUsdt: 0,
        };
      }

      summary[key].players.add(bet.username);
      summary[key].totalTsh += Number(bet.betInTsh || 0);
      summary[key].totalUsdt += Number(bet.betInUsdt || 0);
    });

    return Object.entries(summary).map(([match, d]) => ({
      match,
      players: d.players.size,
      totalTsh: d.totalTsh,
      totalUsdt: d.totalUsdt,
    }));
  })();

  // ================= UPDATE BET =================
  async function updateBet(bet) {
    try {
      const ref = doc(db, "userBets", bet.id);
      const edited = editedBets[bet.id] || {};

      const updateData = {
        teamA: edited.teamA ?? bet.teamA,
        teamB: edited.teamB ?? bet.teamB,
        selectedScore:
          edited.selectedScore ?? bet.selectedScore,
        odds: Number(edited.odds ?? bet.odds),
        matchDate: edited.matchDate ?? bet.matchDate,
        matchTime: edited.matchTime ?? bet.matchTime,
      };

      if (bet.betInTsh) {
        updateData.betInTsh = Number(
          edited.amount ?? bet.betInTsh
        );
      }

      if (bet.betInUsdt) {
        updateData.betInUsdt = Number(
          edited.amount ?? bet.betInUsdt
        );
      }

      await updateDoc(ref, updateData);
      showMessage("✅ Bet imehaririwa kikamilifu");
      fetchBets();
    } catch (err) {
      console.error("UPDATE ERROR:", err);
      showMessage("❌ Imeshindikana kuhariri bet");
    }
  }

  if (loading) return <p>Inapakia...</p>;

  return (
    <div className="admin-hacking-container">
      <h2>🛡️ Admin User Bet History & Match Control</h2>

      {message && <p className="success-text">{message}</p>}

      {/* SEARCH */}
      <input
        type="text"
        placeholder="🔍 Search username..."
        value={searchUsername}
        onChange={(e) => setSearchUsername(e.target.value)}
        className="search-input"
      />

      <p>
        Bets found: <b>{filteredBets.length}</b>
      </p>

      {/* SUMMARY */}
      <h3>📊 Muhtasari wa Mechi</h3>
      <table className="summary-table">
        <thead>
          <tr>
            <th>Match</th>
            <th>Players</th>
            <th>Total TSH</th>
            <th>Total USDT</th>
          </tr>
        </thead>
        <tbody>
          {matchSummary.map((m) => (
            <tr key={m.match}>
              <td>{m.match}</td>
              <td>{m.players}</td>
              <td>{m.totalTsh.toLocaleString()}</td>
              <td>{m.totalUsdt.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* DUPLICATES */}
      {suspiciousGroups.length > 0 && (
        <>
          <h3>🚨 Suspicious Duplicate Bets</h3>
          <table className="bets-table highlighted-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Match</th>
                <th>Amount</th>
                <th>Times</th>
              </tr>
            </thead>
            <tbody>
              {suspiciousGroups.map((g, i) => (
                <tr key={i}>
                  <td>{g[0].username}</td>
                  <td>
                    {g[0].teamA} vs {g[0].teamB}
                  </td>
                  <td>{g[0].betInTsh || g[0].betInUsdt}</td>
                  <td>{g.length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* EDIT TABLE */}
      <h3>✏️ Edit Bets</h3>
      <table className="bets-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Team A</th>
            <th>Team B</th>
            <th>Score</th>
            <th>Odds</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Time</th>
            <th>Save</th>
          </tr>
        </thead>
        <tbody>
          {filteredBets.map((bet) => (
            <tr key={bet.id}>
              <td>{bet.username}</td>

              <td>
                <input
                  defaultValue={bet.teamA}
                  onChange={(e) =>
                    handleEdit(bet.id, "teamA", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  defaultValue={bet.teamB}
                  onChange={(e) =>
                    handleEdit(bet.id, "teamB", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  defaultValue={bet.selectedScore}
                  onChange={(e) =>
                    handleEdit(
                      bet.id,
                      "selectedScore",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                <input
                  type="number"
                  defaultValue={bet.odds}
                  onChange={(e) =>
                    handleEdit(bet.id, "odds", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="number"
                  defaultValue={bet.betInTsh || bet.betInUsdt}
                  onChange={(e) =>
                    handleEdit(bet.id, "amount", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="date"
                  defaultValue={bet.matchDate}
                  onChange={(e) =>
                    handleEdit(
                      bet.id,
                      "matchDate",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                <input
                  type="time"
                  defaultValue={bet.matchTime}
                  onChange={(e) =>
                    handleEdit(
                      bet.id,
                      "matchTime",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                <button onClick={() => updateBet(bet)}>
                  Save
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}